module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Archer_S10.da4ab4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Archer_S10.jpg
// module id = U1GG
// module chunks = 0